module.exports = __webpack_public_path__ + "img/yourStory@2x.4209f5c.webp";